import React from 'react';

// Line-art for the "What's new" section. One glyph per entry (keyed by
// `art` in data/whatsNew.js). Hairline structure, teal for the live part,
// gold for the one thing in motion. Decorative only.
const BOX = {
  adopt: [320, 156],
  catchup: [320, 156],
  policy: [320, 156],
  secrets: [320, 156],
  router: [320, 156],
  economics: [320, 156],
  voice: [320, 156],
  fleet: [320, 156],
  hands: [320, 156],
  bugs: [320, 156],
  proof: [320, 156],
};

function Adopt() {
  const cards = [
    { y: 16, dash: false, lines: [36, 22, 28] },
    { y: 58, dash: false, lines: [22, 30] },
    { y: 100, dash: true, lines: [28, 16, 24] },
  ];
  return (
    <>
      {cards.map((c) => (
        <g key={c.y}>
          <rect x={16} y={c.y} width={86} height={40} rx={4} className={c.dash ? 'wn-line wn-dash' : 'wn-fill'} />
          {c.lines.map((w, i) => (
            <path key={w} d={`M28 ${c.y + 12 + i * 10} h${w}`} className="wn-line" />
          ))}
          <path d={`M102 ${c.y + 20} C 130 ${c.y + 20}, 142 78, 168 78`} className="wn-line" />
        </g>
      ))}
      <rect x={168} y={22} width={112} height={112} rx={6} className="wn-fill" />
      <path d="M168 40 h112" className="wn-line" />
      <circle cx={182} cy={31} r={3} className="wn-surf-fill" />
      <path d="M184 58 h72 M184 72 h56 M184 86 h64" className="wn-line" />
      <path d="M184 108 h28" className="wn-gold" />
      <path d="M280 100 h14" className="wn-line wn-dash" />
      <ellipse cx={306} cy={108} rx={12} ry={5} className="wn-gold" />
      <path d="M294 108 v-10 h24 v10" className="wn-gold" />
      <ellipse cx={306} cy={98} rx={12} ry={5} className="wn-gold" />
    </>
  );
}

function Catchup() {
  return (
    <>
      <rect x={16} y={20} width={128} height={116} rx={6} className="wn-fill" />
      <path d="M16 40 h128" className="wn-line" />
      <circle cx={30} cy={30} r={3} className="wn-surf-fill" />
      <path d="M32 58 h80 M32 72 h64 M32 86 h72 M32 100 h40" className="wn-line" />
      <path d="M152 78 h22" className="wn-gold" />
      <path d="M168 70 l10 8 l-10 8" className="wn-gold" />
      {[
        [20, true],
        [64, false],
        [108, false],
      ].map(([y, on]) => (
        <g key={y}>
          <rect x={188} y={y} width={116} height={36} rx={4} className={on ? 'wn-surf-fill' : 'wn-fill'} />
          <path d={`M202 ${y + 14} h${on ? 48 : 64}`} className={on ? 'wn-on-inv' : 'wn-line'} />
          <path d={`M202 ${y + 24} h36`} className={on ? 'wn-on-inv' : 'wn-line'} />
        </g>
      ))}
      <path d="M278 34 l6 6 l12 -12" className="wn-on-inv" />
    </>
  );
}

function Policy() {
  return (
    <>
      <rect x={36} y={48} width={150} height={84} rx={4} className="wn-line" />
      <rect x={28} y={40} width={150} height={84} rx={4} className="wn-line" />
      <rect x={20} y={32} width={150} height={84} rx={4} className="wn-fill" />
      <path d="M36 52 h70 M36 66 h108 M36 80 h88" className="wn-line" />
      <path d="M36 94 h48" className="wn-gold" />
      <text x={132} y={102} className="wn-label">v3</text>
      <path d="M178 74 C 210 74, 214 40, 236 40" className="wn-gold" />
      <path d="M228 32 l8 8 l-12 4" className="wn-gold" />
      <rect x={236} y={28} width={68} height={52} rx={4} className="wn-fill" />
      <path d="M248 46 h40 M248 58 h28" className="wn-line" />
      <text x={248} y={72} className="wn-label">v4</text>
    </>
  );
}

function Secrets() {
  return (
    <>
      <rect x={16} y={36} width={128} height={88} rx={6} className="wn-fill" />
      <path d="M32 58 h40" className="wn-line" />
      <rect x={32} y={70} width={96} height={28} rx={4} className="wn-line" />
      <path d="M44 84 h8 M58 84 h8 M72 84 h8 M86 84 h8" className="wn-gold" />
      <path d="M152 80 h28" className="wn-gold" />
      <path d="M174 72 l8 8 l-8 8" className="wn-gold" />
      <rect x={188} y={36} width={116} height={88} rx={6} className="wn-fill" />
      <path d="M188 54 h116" className="wn-line" />
      <circle cx={204} cy={45} r={3} className="wn-surf-fill" />
      <path d="M204 78 h64" className="wn-line" />
      <path d="M204 96 h8 M218 96 h8 M232 96 h8" className="wn-line" />
    </>
  );
}

function Router() {
  return (
    <>
      <rect x={16} y={62} width={64} height={32} rx={4} className="wn-fill" />
      <path d="M28 78 h28" className="wn-line" />
      <path d="M80 78 h28" className="wn-line" />
      <rect x={108} y={50} width={72} height={56} rx={4} className="wn-gold" />
      <path d="M122 70 h44 M122 84 h28" className="wn-gold" />
      {[28, 66, 104].map((y, i) => (
        <g key={y}>
          <path d={`M180 78 C 200 78, 206 ${y + 14}, 220 ${y + 14}`} className={i === 1 ? 'wn-gold' : 'wn-line'} />
          <rect x={220} y={y} width={84} height={28} rx={14} className={i === 1 ? 'wn-surf-fill' : 'wn-fill'} />
          <path d={`M236 ${y + 14} h36`} className={i === 1 ? 'wn-on-inv' : 'wn-line'} />
        </g>
      ))}
    </>
  );
}

function Economics() {
  const bars = [
    { x: 48, h: 72, hot: false },
    { x: 136, h: 46, hot: false },
    { x: 224, h: 88, hot: true },
  ];
  return (
    <>
      <path d="M32 124 h256" className="wn-line" />
      {bars.map((b) => (
        <rect key={b.x} x={b.x} y={124 - b.h} width={48} height={b.h} rx={3} className={b.hot ? 'wn-surf-fill' : 'wn-fill'} />
      ))}
      <text x={54} y={142} className="wn-label">Cost</text>
      <text x={146} y={142} className="wn-label">List</text>
      <text x={228} y={142} className="wn-label">Billed</text>
    </>
  );
}

function Voice() {
  const wave = [28, 48, 22, 58, 36, 64, 30, 50, 24];
  return (
    <>
      <rect x={16} y={48} width={78} height={56} rx={4} className="wn-fill" />
      <path d="M28 70 h40 M28 84 h24" className="wn-line" />
      <path d="M94 76 h22" className="wn-gold" />
      {wave.map((h, i) => (
        <path key={i} d={`M${124 + i * 8} ${78 - h / 2} v${h}`} className="wn-gold" />
      ))}
      <rect x={204} y={28} width={100} height={100} rx={6} className="wn-fill" />
      <path d="M204 46 h100" className="wn-line" />
      <path d="M238 86 v18 M246 74 v36 M254 82 v20 M262 70 v40 M270 80 v22" className="wn-on" />
    </>
  );
}

function Fleet() {
  const racks = [20, 124, 228];
  return (
    <>
      {racks.map((x, i) => (
        <g key={x}>
          <rect x={x} y={24} width={72} height={108} rx={4} className={i === 2 ? 'wn-line wn-dash' : 'wn-fill'} />
          {i < 2 && [0, 1, 2, 3].map((n) => (
            <rect key={n} x={x + 12} y={40 + n * 20} width={48} height={12} rx={2} className={i === 0 && n === 1 ? 'wn-gold' : 'wn-line'} />
          ))}
        </g>
      ))}
      <path d="M92 78 H124" className="wn-gold" />
      <circle cx={108} cy={68} r={4} className="wn-surf-fill" />
      <path d="M252 70 h24 M264 58 v24" className="wn-gold" />
    </>
  );
}

function Hands() {
  return (
    <>
      <rect x={20} y={18} width={280} height={120} rx={6} className="wn-fill" />
      <path d="M20 38 h280" className="wn-line" />
      <rect x={36} y={52} width={52} height={70} rx={3} className="wn-line" />
      <path d="M46 68 h32 M46 82 h24 M46 96 h28" className="wn-line" />
      <rect x={108} y={64} width={88} height={28} rx={4} className="wn-surf-fill" />
      <path d="M120 78 h48" className="wn-on-inv" />
      <rect x={214} y={64} width={68} height={28} rx={4} className="wn-line" />
      <path d="M234 70 l16 16 M250 70 l-16 16" className="wn-gold" />
      <path d="M168 108 l10 16 l6 -28" className="wn-gold" />
    </>
  );
}

function Bugs() {
  return (
    <>
      <rect x={16} y={28} width={108} height={100} rx={8} className="wn-fill" />
      <rect x={30} y={42} width={80} height={44} rx={3} className="wn-line" />
      <path d="M40 58 h36 M40 70 h24" className="wn-line" />
      <path d="M30 100 h60" className="wn-line" />
      <path d="M132 78 h24" className="wn-gold" />
      <path d="M150 70 l10 8 l-10 8" className="wn-gold" />
      <rect x={168} y={40} width={80} height={76} rx={4} className="wn-fill" />
      <path d="M180 58 h48" className="wn-gold" />
      <path d="M180 74 h36 M180 90 h28" className="wn-line" />
      <circle cx={280} cy={78} r={18} className="wn-surf-fill" />
      <path d="M270 78 l7 7 l14 -16" className="wn-on-inv" />
    </>
  );
}

function Connectors() {
  const ys = [14, 28, 42, 56, 70, 84];
  return (
    <>
      {ys.map((y, i) => (
        <g key={y}>
          <rect x={18} y={y - 6} width={46} height={12} rx={3} className="wn-fill" />
          <path d={`M64 ${y} C 110 ${y}, 120 48, 158 48`} className={i % 2 ? 'wn-line wn-dash' : 'wn-line'} />
        </g>
      ))}
      <circle cx={170} cy={48} r={13} className="wn-surf-fill" />
      <path d="M163 48 l5 5 l10 -10" className="wn-on-inv" />
      <rect x={192} y={36} width={32} height={24} rx={4} className="wn-gold" />
      <path d="M198 44 h20 M198 50 h14" className="wn-gold" />
    </>
  );
}

function Models() {
  const rows = [22, 40, 58, 76];
  return (
    <>
      {rows.map((y, i) => (
        <g key={y}>
          <rect x={16} y={y - 7} width={52} height={14} rx={3} className="wn-fill" />
          <path d={`M24 ${y} h${i === 1 ? 28 : 18}`} className="wn-line" />
          <path d={`M68 ${y} C 100 ${y}, 108 48, 138 48`} className={i % 2 ? 'wn-line wn-dash' : 'wn-line'} />
        </g>
      ))}
      <rect x={138} y={32} width={28} height={32} rx={4} className="wn-surf-fill" />
      <path d="M146 44 h12 M146 52 h8" className="wn-on-inv" />
      <rect x={178} y={36} width={46} height={24} rx={4} className="wn-gold" />
      <path d="M188 48 h26" className="wn-gold" />
    </>
  );
}

function Room() {
  return (
    <>
      <rect x={16} y={18} width={208} height={64} rx={4} className="wn-fill" />
      <rect x={28} y={30} width={14} height={40} rx={2} className="wn-gold" />
      <path d="M42 50 h40" className="wn-line" />
      <circle cx={94} cy={50} r={4.5} className="wn-surf-fill" />
      <path d="M99 50 h24" className="wn-line" />
      {[132, 154, 176, 198].map((x, i) => (
        <rect key={x} x={x} y={30} width={12} height={40} rx={2} className={i === 1 ? 'wn-surf-fill' : 'wn-line'} />
      ))}
    </>
  );
}

function Support() {
  return (
    <>
      <rect x={16} y={28} width={72} height={40} rx={10} className="wn-fill" />
      <path d="M28 44 h36 M28 54 h24" className="wn-line" />
      <path d="M94 48 h16" className="wn-line" />
      <rect x={114} y={18} width={68} height={60} rx={4} className="wn-fill" />
      <path d="M124 36 h44 M124 48 h32 M124 60 h24" className="wn-line" />
      <circle cx={206} cy={48} r={14} className="wn-gold" />
      <path d="M199 48 l5 5 l10 -10" className="wn-on" />
    </>
  );
}

function Build() {
  return (
    <>
      <rect x={16} y={20} width={70} height={56} rx={4} className="wn-fill" />
      <path d="M28 36 h28 M28 48 h40 M28 60 h22" className="wn-line" />
      <path d="M94 48 h16" className="wn-line" />
      <path d="M106 42 l6 6 l-6 6" className="wn-line" />
      <rect x={124} y={16} width={100} height={64} rx={6} className="wn-fill" />
      <path d="M124 30 h100" className="wn-line" />
      <circle cx={134} cy={23} r={2} className="wn-surf-fill" />
      <path d="M156 52 l8 8 l18 -20" className="wn-on" />
    </>
  );
}

function Checkout() {
  return (
    <>
      <rect x={16} y={16} width={92} height={64} rx={4} className="wn-fill" />
      <path d="M28 32 h48 M28 46 h36 M28 60 h24" className="wn-line" />
      <path d="M116 48 h16" className="wn-gold" />
      <rect x={136} y={16} width={88} height={64} rx={4} className="wn-fill" />
      <path d="M148 32 h52 M148 46 h40" className="wn-line" />
      <rect x={148} y={56} width={60} height={14} rx={3} className="wn-gold" />
    </>
  );
}

function Fold() {
  return (
    <>
      <rect x={28} y={16} width={70} height={64} rx={3} className="wn-fill" />
      <path d="M40 32 h28 M40 46 h20 M40 60 h24" className="wn-line" />
      <path d="M98 16 v64" className="wn-gold" />
      <rect x={98} y={16} width={114} height={64} rx={3} className="wn-fill" />
      <path d="M114 34 h72 M114 48 h56 M114 62 h64" className="wn-line" />
    </>
  );
}

function Mcp() {
  const ys = [24, 48, 72];
  return (
    <>
      {ys.map((y) => (
        <g key={y}>
          <rect x={16} y={y - 10} width={36} height={20} rx={4} className="wn-fill" />
          <path d={`M52 ${y} C 88 ${y}, 100 48, 130 48`} className="wn-line" />
        </g>
      ))}
      <rect x={130} y={30} width={42} height={36} rx={4} className="wn-surf-fill" />
      <path d="M140 44 h22 M140 52 h14" className="wn-on-inv" />
      <path d="M172 48 h16" className="wn-line" />
      <path d="M190 52 l5 5 l12 -12" className="wn-on" />
    </>
  );
}

// A browser frame with the feature driven, a verdict pinned to a commit
// hash, and the next hash beside it still empty (stale, not passing).
function Proof() {
  return (
    <>
      <rect x={16} y={16} width={176} height={124} rx={6} className="wn-fill" />
      <path d="M16 36 h176" className="wn-line" />
      <circle cx={30} cy={26} r={3} className="wn-surf-fill" />
      <circle cx={42} cy={26} r={3} className="wn-surf-fill" />
      <rect x={36} y={56} width={100} height={20} rx={3} className="wn-line" />
      <path d="M44 66 h60" className="wn-line" />
      <rect x={36} y={88} width={56} height={24} rx={4} className="wn-surf-fill" />
      <path d="M48 100 h32" className="wn-on-inv" />
      <path d="M150 62 l8 8 l16 -16" className="wn-gold" />
      <rect x={212} y={40} width={92} height={32} rx={4} className="wn-fill" />
      <path d="M224 56 h44" className="wn-line" />
      <path d="M278 50 l5 5 l10 -10" className="wn-on" />
      <rect x={212} y={88} width={92} height={32} rx={4} className="wn-line" strokeDasharray="4 4" />
      <path d="M224 104 h44" className="wn-line" />
    </>
  );
}

// Three workers fanning out from one ask, converging on a judge.
function Graph() {
  const ys = [24, 48, 72];
  return (
    <>
      <rect x={16} y={36} width={40} height={24} rx={4} className="wn-fill" />
      {ys.map((y) => (
        <g key={y}>
          <path d={`M56 48 C 80 48, 90 ${y + 12}, 110 ${y + 12}`} className="wn-line" />
          <rect x={110} y={y} width={44} height={24} rx={4} className="wn-fill" />
          <path d={`M154 ${y + 12} C 176 ${y + 12}, 184 48, 200 48`} className="wn-line" />
        </g>
      ))}
      <rect x={200} y={36} width={28} height={24} rx={4} className="wn-surf-fill" />
      <path d="M207 48 l5 5 l10 -10" className="wn-on-inv" />
    </>
  );
}

// Three rungs: confirm, verify, autopilot; the first lit.
function Ladder() {
  return (
    <>
      <path d="M40 16 v64 M200 16 v64" className="wn-line" />
      {[28, 48, 68].map((y, i) => (
        <g key={y}>
          <path d={`M40 ${y} h160`} className={i === 0 ? 'wn-gold' : 'wn-line'} />
          <rect x={52} y={y - 7} width={i === 0 ? 48 : 36} height={14} rx={3} className={i === 0 ? 'wn-surf-fill' : 'wn-fill'} />
        </g>
      ))}
    </>
  );
}

const ART = {
  adopt: Adopt,
  proof: Proof,
  graph: Graph,
  ladder: Ladder,
  catchup: Catchup,
  policy: Policy,
  secrets: Secrets,
  router: Router,
  economics: Economics,
  voice: Voice,
  fleet: Fleet,
  hands: Hands,
  bugs: Bugs,
  connectors: Connectors,
  models: Models,
  room: Room,
  support: Support,
  build: Build,
  checkout: Checkout,
  fold: Fold,
  mcp: Mcp,
};

export default function WhatsNewArt({ kind }) {
  const Glyph = ART[kind];
  if (!Glyph) return null;
  const [w, h] = BOX[kind] || [240, 96];
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="wn-art" aria-hidden="true" focusable="false">
      <Glyph />
    </svg>
  );
}
